import { makeLazy } from "lib/make-lazy"

export const CompareTwo = makeLazy(() => import("./compare-two-impl.js"), "CompareTwoImpl")
